import { FEED_PC_AUTO_APPEND_MAX } from '@/constants/feed-pagination.js';

export function paginatedFeedGetPlatform(store) {
  return store.lastFetchPlatform === 'h5' ? 'h5' : 'pc';
}

export function paginatedFeedIsAppendAutoLoadBlocked(store) {
  return Boolean(store.appendAutoLoadBlocked);
}

/** append 失败时熔断自动 loadMore，避免网络错误触发无限重试 */
export function paginatedFeedBlockAutoLoad(store) {
  store.appendAutoLoadBlocked = true;
}

export function paginatedFeedClearAutoLoadBlock(store) {
  store.appendAutoLoadBlocked = false;
}

export function paginatedFeedIsManualLoadRequired(store) {
  // H5 无手动「加载更多」入口，仅 PC 启用 append 上限
  if (paginatedFeedGetPlatform(store) !== 'pc') return false;
  if (paginatedFeedIsAppendAutoLoadBlocked(store)) return true;
  return (store.autoAppendCount ?? 0) >= FEED_PC_AUTO_APPEND_MAX;
}

export function paginatedFeedShouldAutoLoad(store) {
  if (paginatedFeedIsAppendAutoLoadBlocked(store)) return false;
  return !paginatedFeedIsManualLoadRequired(store);
}

export function paginatedFeedResetAutoAppendCount(store) {
  store.autoAppendCount = 0;
  paginatedFeedClearAutoLoadBlock(store);
}

export function paginatedFeedRecordAppend(store) {
  store.autoAppendCount = (store.autoAppendCount ?? 0) + 1;
}

/** A source may explicitly resume an empty page whose cursor still has more data. */
export function paginatedFeedCanLoadMore(store, options = {}) {
  if (store.listLoading || store.loadingMore || !store.hasMore) return false;
  return Boolean(
    store.rawRows.length ||
      (typeof options.canLoadEmpty === 'function' && options.canLoadEmpty(store))
  );
}
